/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../../api/types.generated";
export type GetSponsorCompaniesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetSponsorCompaniesQuery = { __typename?: "Query" } & {
  claims: Array<
    { __typename?: "Claim" } & Pick<Types.Claim, "id" | "name" | "stage_id"> & {
        fields: Array<
          { __typename?: "FieldWithAnswer" } & Pick<
            Types.FieldWithAnswer,
            "id" | "field_type" | "slug" | "valid_values" | "updated_at"
          > & {
              answer?: Types.Maybe<
                { __typename?: "FieldAnswer" } & Pick<
                  Types.FieldAnswer,
                  "id" | "value" | "updated_at"
                >
              >;
            }
        >;
      }
  >;
};

export const GetSponsorCompaniesDocument = gql`
  query GetSponsorCompanies {
    claims(
      where: {
        pipeline: {
          is: { slug: { equals: "hackthenorth2020-sponsor-companies" } }
        }
      }
    ) {
      id
      name
      stage_id
      fields {
        id
        field_type
        slug
        answer {
          id
          value
          updated_at
        }
        valid_values
        updated_at
      }
    }
  }
`;

/**
 * __useGetSponsorCompaniesQuery__
 *
 * To run a query within a React component, call `useGetSponsorCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSponsorCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSponsorCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSponsorCompaniesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetSponsorCompaniesQuery,
    GetSponsorCompaniesQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetSponsorCompaniesQuery,
    GetSponsorCompaniesQueryVariables
  >(GetSponsorCompaniesDocument, baseOptions);
}
export function useGetSponsorCompaniesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetSponsorCompaniesQuery,
    GetSponsorCompaniesQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetSponsorCompaniesQuery,
    GetSponsorCompaniesQueryVariables
  >(GetSponsorCompaniesDocument, baseOptions);
}
export type GetSponsorCompaniesQueryHookResult = ReturnType<
  typeof useGetSponsorCompaniesQuery
>;
export type GetSponsorCompaniesLazyQueryHookResult = ReturnType<
  typeof useGetSponsorCompaniesLazyQuery
>;
export type GetSponsorCompaniesQueryResult = ApolloReactCommon.QueryResult<
  GetSponsorCompaniesQuery,
  GetSponsorCompaniesQueryVariables
>;
